<template>
  <eco-tree-list-dialog
    :single="single"
    :data="data"
    :table-columns="tableColumns"
    :pagination="pagination"
    :tree-data="treeData"
    :default-expanded-keys="['6']"
    dialog-title="审查规则库"
    :append-to-body="appendToBody"
    @load="handleLoad"
    @loadListData="loadListData"
    @onConfirm="onConfirm"
    @reset="reset"
    quickSearchProps="ruleName"
    search-placeholder="规则名称"
    :destroy-on-close="destroyOnClose"
    selectLabel="ruleName"
    ref="ecoTreeListDialog"
  />
</template>
<script>
import req from "@/request.js";
import portal from "@/api/portal.js";

export default {
  name: "default-rules-dialog",
  props: {
    value: Array,
    single: Boolean,
    name:String,
    formType: {
      type: String,
      default: "pc"
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    destroyOnClose:{
      type: Boolean,
      default: false
    },
    rightType: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      data: [],
      treeData: null,
      tableColumns: [
        { prop: "riskLevel", label: "风险等级",width:"100" },
        { prop: "ruleName", label: "规则名称",width:"150" },
        { prop: "ruleDesc", label: "规则描述" }
      ],
      pagination: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      typeIdQuery: null
    };
  },
  mounted() {
  },
  methods: {
    loadTreeData() {
      portal.getAiContractRuleType().then(data => {
        this.treeData = data;
      });
    },
    showDialog(params) {
      this.loadTreeData();
      if (!params){
        params = [];
      }
      this.$refs.ecoTreeListDialog.showDialog(params);
    },
    handleLoad(param, cb) {
      if (this.typeIdQuery) {
        param.querys.push(this.typeIdQuery);
      }
      param.params = param.params || {};
      if (this.rightType) {
        param.params['REF_ID_']= this.rightType;
      }
      // 参数说明  url  requestBodyParam  requestParam
      req.post("${portal}/portal_contract_rule_detail/default", param)
        .then(data => {
          let response = data.data;
          this.data = response.rows;
          this.pagination = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          };
        })
        .finally(() => cb());
    },
    loadListData(nodedata) {
      let queryFilter = {
        pageBean: this.pagination,
        querys: []
      };
      this.typeIdQuery = {
        property: "REF_ID_",
        value: nodedata.id,
        group: "categoryGroup",
        operation: "EQUAL",
        relation: "AND"
      };
      this.handleLoad(queryFilter, () => {});
    },
    onConfirm(selection) {
      this.$emit("onConfirm", selection,this.name);
      this.$emit("input", selection);
    },
    reset() {
      /**
       * 点击重置按钮
       * 1. 清空树条件  this.typeIdQuery = "";
       * 2. 清空树选中状态
       * */
      if (this.typeIdQuery) {
        this.$refs.ecoTreeListDialog.$refs.tree.$refs.elTree.currentNode.node.isCurrent = false;
      }
      this.typeIdQuery = "";
    }
  }
};
</script>

<style lang="scss">
.left-aside {
  height: 600px;

}
.left-aside .el-card__body {
  padding: 0px;
}
</style>
